import './index.css';

// 44club interactive globe
var degrees = document.querySelectorAll("[id^='degree-'].degree--filled");
const donators = document.querySelectorAll('.page-community__donator');

degrees.forEach((element, index) => {
  element.addEventListener('mouseenter', () => {
    // Change the styling of the corresponding element
    donators[index].classList.add('page-community__donator--active');
  });

  element.addEventListener('mouseleave', () => {
    // Reset the styling of the corresponding element
    donators[index].classList.remove('page-community__donator--active');
  });

  element.addEventListener('touchstart', () => {
    // Change the styling of the corresponding element on touch
    donators[index].classList.add('page-community__donator--active');
  });

  element.addEventListener('touchend', () => {
    // Reset the styling of the corresponding element after touch
    donators[index].classList.remove('page-community__donator--active');
  });

  // Attach event listeners to each styled element
  donators[index].addEventListener('mouseenter', () => {
    // Change the styling of the corresponding watched element
    element.classList.add('degree--hovered');
  });

  donators[index].addEventListener('mouseleave', () => {
    // Reset the styling of the corresponding watched element
    element.classList.remove('degree--hovered');
  });

  donators[index].addEventListener('touchstart', () => {
    // Change the styling of the corresponding watched element on touch
    element.classList.add('degree--hovered');
  });

  donators[index].addEventListener('touchend', () => {
    // Reset the styling of the corresponding watched element after touch
    element.classList.remove('degree--hovered');
  });
});
